// scripts.js.liquid
// preload jquery before running any other scripts
// add any jQuery dependant scripts into otherFunctions()

function loadJQuery(callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  /* self-hosted (same CDN as the page) - saves a third-party DNS+TLS+fetch on
     every visit; the file is stock jQuery 3.7.1, drop-in for 3.6 */
  script.src = "//quickplaysport.eu/cdn/shop/t/15/assets/hosted-jquery-3-7-1-min.js?v=147293088974801289311790260017";
  script.onload = callback;
  document.head.appendChild(script);
}


function activateMobileMenu() {
    let menuOpen = false;

    $('.mobileMenuOpenSwitch').on('click', function() {
        $('.mobileMenuOpenSwitch').hide();
        $('.mobileMenuCloseSwitch').fadeIn();

        $('.mainMenuV2').addClass('mainMenuV2--active');
        $('body, html').addClass('body__noScroll');
        menuOpen = true;
    });

    $('.mobileMenuCloseSwitch').on('click', function() {
        $('.mobileMenuCloseSwitch').hide();
        $('.mobileMenuOpenSwitch').fadeIn();

        $('.mainMenuV2').removeClass('mainMenuV2--active');
        $('body, html').removeClass('body__noScroll');
        menuOpen = false;
    });

    // Sub-menu toggling
        // We change the click target from the whole div to just the arrow area
        $('.fakelinkV2 .js-menu-toggle').click(function() {
            var MenuOpener = $(this).find('.menuOpener');

            MenuOpener.toggleClass('rotated');

            // We use .closest() to find the parent div, then find the next 'ul'
            $(this).closest('.fakelinkV2').next('ul').slideToggle();
        });


    // NEW: Handle clicks on the text when it's NOT a link
        $('.fakelinkV2 .js-menu-toggle-text').css('cursor', 'pointer').on('click', function() {
          // Find the arrow's span (its sibling) and trigger a click
          $(this).siblings('.js-menu-toggle').click();
        });




        // Sub-sub-menu toggling
        // We change the click target from the whole div to just the arrow area
        $('.fakesublinkV2 .js-submenu-toggle').click(function() {
            var subMenuOpener = $(this).find('.subMenuOpener');

            subMenuOpener.toggleClass('rotated');

            // We use .closest() to find the parent div, then find the next 'ul'
            $(this).closest('.fakesublinkV2').next('ul').slideToggle();
        });


    // NEW: Handle clicks on the sub-menu text when it's NOT a link
        $('.fakesublinkV2 .js-submenu-toggle-text').css('cursor', 'pointer').on('click', function() {
          // Find the arrow's span (its sibling) and trigger a click
          $(this).siblings('.js-submenu-toggle').click();
        });




    // Window resize event to manage the body__noScroll class
    $(window).resize(function() {
        if ($(window).width() > 1024) {
            $('body, html').removeClass('body__noScroll');
        } else if (menuOpen) {
            $('body, html').addClass('body__noScroll');
        }
    });
}




// We add 'element' as a second argument
function openCustomMobMenu(customDiv, element) {
  // Select the menu opener element within the clicked 'element'
  var $menuOpener = $(element).find('.menuOpener');

  // Add the rotation logic from the other menu functions
  $menuOpener.toggleClass('rotated');

  // Slide toggle the target div using jQuery
  $('#' + customDiv).slideToggle();
}
function activateDTMenu() {
  $('.fakelinkDT').on('mouseenter', function() {
    // Remove the active class from all ul elements within the .mainMenuV2 container
    $('.mainMenuV2 ul').removeClass('mainMenuV2Sublinks--active');
	$('.customDropDown').removeClass('customDropDown--active');

    // Target the next ul element after .fakelinkV2 within the same parent container
    var $nextUl = $(this).next('.fakelinkV2').next('ul');

    // Log the class of the target ul element
   //console.log($nextUl.attr('class'));

    // Add the active class to the targeted ul element
    $nextUl.addClass('mainMenuV2Sublinks--active');
  });

  // Hide the menu when mouse leaves the area
  $('.mainMenuV2').on('mouseleave', function() {
    // Remove the active class from all ul elements within the .mainMenuV2 container
    $('.mainMenuV2 ul').removeClass('mainMenuV2Sublinks--active');
  });

}


///// custom menu function
function closeCustomMenu(customDiv){
    $('.customDropDown').removeClass('customDropDown--active');
}

function openCustomMenu(customDiv) {
  // Get the target div element
  var $targetDiv = $('#' + customDiv);

  // Remove any inline display: none style (if present)
  if ($targetDiv.css('display') === 'none') {
    $targetDiv.css('display', '');
  }

  // Reset active classes (optional)
  $('.mainMenuV2 ul').removeClass('mainMenuV2Sublinks--active');
  $('.customDropDown').removeClass('customDropDown--active');

  // Add the active class to the specific custom dropdown
  $targetDiv.addClass('customDropDown--active');
}

function createSlider(sliderClass) {
  const slider = document.querySelector(sliderClass);

  // Check if the slider element exists
  if (slider) {
    slider.addEventListener('wheel', (e) => {
      // Prevent default wheel action
      e.preventDefault();

      // Calculate the amount to scroll
      const scrollAmount = e.deltaY;

      // Scroll one slide at a time
      slider.scrollLeft += scrollAmount > 0 ? window.innerWidth : -window.innerWidth;
    }, { passive: false });
  }
}
































function updateActualCart(rootItem, newQuantity) {
  if (newQuantity === undefined) {
    console.error("newQuantity is undefined. Cannot update cart.");
    return;
  }

  // Find the item-quantity input within rootItem
  const quantityInput = rootItem.querySelector(".item-quantity");
  const rootItemParent = rootItem.parentElement;
  const priceElement = rootItemParent.querySelector(".item-total");
  //console.log(rootItemParent);

  let quantityInputHidden = rootItem.querySelector(".actualCartHiddenQty");

  // Update the input's value with the newQuantity
  if (quantityInput) {
    quantityInput.value = newQuantity;
    quantityInputHidden.value = newQuantity;
  } else {
    console.error("Could not find .item-quantity input within the provided element.");
  }

  // Get the item price from the data attribute
  const itemPriceString = rootItem.dataset.itemPrice;
  const itemPrice = parseFloat(itemPriceString) / 100;

  // Calculate and update the total price
  if (!isNaN(itemPrice)) {
    const totalPrice = itemPrice * newQuantity;

    // Mapping of currency codes to their symbols
    const currencySymbols = {
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'JPY': '¥',
      'AUD': 'A$',
      'CAD': 'C$',
      'CHF': 'CHF',
      'CNY': '¥',
      'SEK': 'kr',
      'NZD': 'NZ$'
    };

    // Function to get the currency symbol
    function getCurrencySymbol(currencyCode) {
      return currencySymbols[currencyCode] || currencyCode;
    }

    // Get the currency code from the element with class .shopCurrency
    const currencyCodeElement = document.querySelector(".shopCurrency");
    let shopCurrency = '';
    if (currencyCodeElement) {
      shopCurrency = currencyCodeElement.innerHTML.trim();
    } else {
      console.error("Could not find .shopCurrency element.");
    }

    const currencySymbol = getCurrencySymbol(shopCurrency);

   // console.log(totalPrice);
    priceElement.innerHTML = currencySymbol + totalPrice.toFixed(2);
  } else {
    console.error("Invalid item price. Cannot update total price.");
  }
}










function activateAccordion() {
  const accordionItems = $('.accordionItem');

  if (accordionItems.length > 0) {
    accordionItems.click(function() {
      $(this).toggleClass('accordionItem--active');
      $(this).next('.accordionText').toggleClass('accordionText--active');
    });
  }
}







/**
 * Debounce Function
 * Delays invoking a function until after 'wait' milliseconds have elapsed
 * since the last time the debounced function was invoked.
 */
function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};



















function predictiveSearch() {
  // --- 1. INITIALIZATION ---

  // Get the currency symbol from Shopify's settings
  const currencySymbol = "<span class=transcy-money>€0,00</span>".replace(/[\d.,\s]/g, '');

  // Retrieve the dontShowListString setting directly
  const dontShowListString = "spare,ws";

  // Retrieve searchSynonyms setting
  const searchSynonymsString = "kickstart: kickster";

  // Parse the comma-separated string into a dictionary
  const searchSynonyms = {};
  if (searchSynonymsString) {
    const synonymPairs = searchSynonymsString.split(',');
    synonymPairs.forEach(function(pairString) {
      const pair = pairString.split('|');
      if (pair.length === 2) {
        searchSynonyms[pair[0].trim()] = pair[1].trim();
      }
    });
  }

  // Check if dontShowListString is not empty or null
  let dontShowList = [];
  if (dontShowListString) {
    // Split the string into an array and clean
    dontShowList = dontShowListString.split(',').map(function(word) {
      return word.trim().toLowerCase();
    });
  }

  // Retrieve the blacklistProducts directly
  const blacklistProducts = null || [];

  // Retrieve the promotedProducts directly
  const promotedProducts = null || [];

  // Retrieve the collectionBlacklist setting
  const collectionBlacklist = ["search-upsells","upsells"] || [];

  // --- 2. HELPER FUNCTIONS ---

  /**
   * Helper function to highlight search terms
   */
  function highlightSearchTerm(text, query) {
    if (!query) return text;
    const regex = new RegExp(query, 'gi'); // Case-insensitive global search
    return text.replace(regex, function(match) {
      return '<strong>' + match + '</strong>';
    });
  }

  /**
   * Renders the product results
   * --- THIS FUNCTION IS UPDATED ---
   */
  function renderProducts(products, q) {
    if (products.length > 0) {
      $("#searchProducts").prepend('<div class="searchTitle"><h3>' + ((window.qpI18n && window.qpI18n.products) || 'Products') + '</h3></div>');

      const promotedElements = [];
      const regularElements = [];
      const queryLower = q.toLowerCase(); // Use the raw query for filtering

      products.forEach(function(product) {
        const prodTitle = product.title.toLowerCase();
        const prodHandle = product.handle;

        // --- Filtering Logic ---
        const isUnavailable = !product.available;
        const isBlacklisted = blacklistProducts.includes(prodHandle);
        const isOnDontShowList = dontShowList.some(word => prodTitle.includes(word));
        const isQueryAllowingDontShow = dontShowList.some(word => queryLower.includes(word));

        let showProduct = true;
        if (isUnavailable || isBlacklisted) {
          showProduct = false;
        }
        if (isOnDontShowList && !isQueryAllowingDontShow) {
          showProduct = false;
        }
        // --- End Filtering Logic ---

        if (showProduct) {
          // --- MODIFIED PRICE LOGIC ---
          //
          // **CHANGE 1:** Use `product.compare_at_price` (min) instead of `product.compare_at_price_max`
          const originalPrice = Number(product.compare_at_price) || 0;
          const finalPrice = Number(product.price) || 0; // This is already the min price

          // **CHANGE 2:** Check if the product has multiple prices
          const hasMultiplePrices = (Number(product.price_min) || 0) !== (Number(product.price_max) || 0);

          // **CHANGE 3:** Set a "From " prefix if it has variants
          const pricePrefix = hasMultiplePrices ? ((window.qpI18n && window.qpI18n.from) || 'From') + ' ' : '';
          // --- END MODIFIED PRICE LOGIC ---

          let priceHTML = '';
          let discountDisplay = '';

          if (originalPrice > finalPrice && originalPrice > 0) {
            // This discount is now correct (e.g., 15.99 vs 14.99)
            const discountPercentage = Math.round(((originalPrice - finalPrice) * 100) / originalPrice);
            discountDisplay = `<div class="discount"><div class="discountBG"> -${discountPercentage}%</div></div>`;

            // **CHANGE 4:** Add the prefix to the price display
            priceHTML = `
              <span class="finalPrice salePrice">${pricePrefix}${currencySymbol}${finalPrice.toFixed(2)}</span>
              <span class="wasprice">${currencySymbol}${originalPrice.toFixed(2)}</span>
            `;
          } else {
            // **CHANGE 5:** Add the prefix to the regular price display
            priceHTML = `<span class="finalPrice">${pricePrefix}${currencySymbol}${finalPrice.toFixed(2)}</span>`;
          }

          const highlightedTitle = highlightSearchTerm(product.title, q);

          // Create the product element with template literals
          const productElement = `
            <div class="searchProduct">
              <a class="predResult" href="/products/${prodHandle}">
                <div class="searchProductImage">
                  <img class="img-fluid" width="100" height="100" src="${product.featured_image.url}"/>
                </div>
                ${discountDisplay}
                <div class="searchProductTitle">${highlightedTitle}</div>
                <div class="featuredProductPrice">${priceHTML}</div>
              </a>
            </div>
          `;

          // Sort into promoted or regular
          if (promotedProducts.includes(prodHandle)) {
            promotedElements.push(productElement);
          } else {
            regularElements.push(productElement);
          }
        }
      });

      // Append promoted first, then regular
      $(".product-container").append(promotedElements.join(''));
      $(".product-container").append(regularElements.join(''));

    } else {
      // No products found message
      $("#searchResults").append(
        '<div class="">' + ((window.qpI18n && window.qpI18n.no_products) || 'No Products Found') + '</div>'
      );
    }
  }

  /**
   * Renders the collection suggestions
   */
  function renderCollections(collections, q) {
    const filteredCollections = collections.filter(function(collection) {
      return !collectionBlacklist.includes(collection.handle);
    });

    if (filteredCollections.length > 0) {
      const collectionsList = filteredCollections.map(function(collection) {
        const highlightedTitle = highlightSearchTerm(collection.title, q);
        return `<li><a href="${collection.url}" title="${collection.title}" class="">${highlightedTitle}</a></li>`;
      }).join('');

      const collectionsHtml = `
        <h3>${(window.qpI18n && window.qpI18n.collections) || 'Collections'}</h3>
        <ul>${collectionsList}</ul>
      `;
      $("#searchCollections").append(collectionsHtml);
    }
  }

  /**
   * Renders the article suggestions
   */
  function renderArticles(articles, q) {
    if (articles.length > 0) {
      const articlesList = articles.map(function(article) {
        const highlightedTitle = highlightSearchTerm(article.title, q);
        return `<li><a href="${article.url}" title="${article.title}" class="">${highlightedTitle}</a></li>`;
      }).join('');

      let articlesHtml = '<ul>' + articlesList + '</ul>';

      // Check if collections/suggestions already added a title
      if ($("#searchSuggestions ul").length === 0) {
         $("#searchArticles").prepend('<h3>' + ((window.qpI18n && window.qpI18n.suggestions) || 'Suggestions') + '</h3>');
      }

      $("#searchArticles").append(articlesHtml);
    }
  }

  // --- 3. EVENT LISTENER ---

  $('#searchInput').keyup(debounce(function() {
    let q = $('#searchInput').val().trim();

    // Replace synonyms in the query
    for (const key in searchSynonyms) {
      // Use word boundaries (\\b) to only replace whole words
      const regex = new RegExp('\\b' + key + '\\b', 'gi');
      q = q.replace(regex, searchSynonyms[key]);
    }

    if (q.length > 0) { // Only make the request if there's a search query
      const encodedQuery = encodeURIComponent(q);

      $.ajax('/search/suggest.json?q=' + encodedQuery + '&resources[type]=product,collection,article', {
        type: 'GET',
        dataType: 'json',
        success: function(response) {
          // Clear previous results and set up containers
          $("#searchResults").empty();
          $("#searchResults").append(`
            <h2>${(window.qpI18n && window.qpI18n.search_results) || 'Search Results'}</h2>
            <div class="searchResuall pltsArea">
              <div class="searchSuggestions" id="searchSuggestions">
                <div id="searchCollections"></div>
                <div id="searchArticles"></div>
              </div>
              <div class="searchProducts" id="searchProducts">
                <div class="product-container"></div>
              </div>
            </div>
          `);

          // Get results
          const { products, collections, articles } = response.resources.results;

          // Render all sections
          renderProducts(products, q);
          renderCollections(collections, q);
          renderArticles(articles, q);

          // Remove 'Suggestions' title if no suggestions are found
          if ($("#searchSuggestions ul li").length === 0) {
            $("#searchSuggestions h3").remove();
          }

          // Refocus
          $("#searchInput").focus();

        },
        error: function(error) {
          console.error('Error fetching suggestions:', error);
          // Refocus even on error
          $("#searchInput").focus();
        }
      });
    } else {
      // Clear results if query is empty
      $("#searchResults").empty();
    }
  }, 300)); // 300ms debounce
}






function activateSearchOpen(){
  $('.searchOpenerImg').click(function() {

 		 $('.searchBackground').fadeIn();

        $('.searchOpenerImg').hide();
        $('.searchCloserImg').fadeIn();


    $('.searchHolder').slideToggle();
		$('#searchInput').focus();

  });

  $('.searchCloserImg').click(function() {

        $('.searchCloserImg').hide();
        $('.searchOpenerImg').fadeIn();

    $('.searchHolder').slideToggle();
  		 $('.searchBackground').fadeOut();
 });

// close by BG
$('.searchBackground').click(function() {

        $('.searchCloserImg').hide();
        $('.searchOpenerImg').fadeIn();

    $('.searchHolder').slideToggle();
  		 $('.searchBackground').fadeOut();
 });
}


function otherFunctions() {
  // Place your other functions here that depend on jQuery
  $(document).ready(function () {
    // Fire all functions here

    // homepage video swap
    if (typeof swapHomepageVideo === 'function') {
      swapHomepageVideo();
    }
    if (typeof swapHomepageVideo2 === 'function') {
      swapHomepageVideo2();
    }

	// activate mobilemenu fading
	activateMobileMenu();

	// activate mobilemenu fading
	activateDTMenu();

	// slider
	createSlider('.icons_with_text_hold');

	// slider
	createSlider('.img4_with_text_hold');

	//accordion
	activateAccordion();

    if (typeof popupTriggers === 'function') {
	popupTriggers();
	}

	//predictiveSearch
	predictiveSearch();

	// search opener
	activateSearchOpen();

    if (typeof loadRecommendedProducts === 'function') {
		loadRecommendedProducts()
	}

    if (typeof updateFilteredCollection === 'function') {
		updateFilteredCollection()
	}

    // 404 search but check for element to make sure we're on it before running
    // Check if we are on the 404 page by looking for the unique element
    var is404Page = document.getElementById('not-found-page');  // Replace with your actual unique element on the 404 page

    if (is404Page) {
      // If we're on the 404 page, run the notFoundSearch function
      notFoundSearch();
    }

    // header bindings are live from here - the menu drawer replays any header
    // tap that landed during the jQuery load (see snippets/qp-menu-drawer.liquid)
    document.dispatchEvent(new Event('qp:header-bound'));
  });
}


function notFoundSearch() {

  // Get the last part of the URL path
  var pathname = window.location.pathname.split('/').pop();

  if (pathname) {
    // Save it in a cookie to pass to Liquid
    document.cookie = "last_part=" + pathname;

    // Create the array where element 0 is the full word, element 1 is the full word minus the last letter, and so on
    var pathnameArray = [];
    for (var i = 0; i < pathname.length; i++) {
      pathnameArray.push(pathname.slice(0, pathname.length - i));
    }

    // Create a string with each element of the array followed by a <br> tag
    var resultString = "";
    pathnameArray.forEach(function(item) {
      resultString += item + "<br>";
    });

    // Show the array in the HTML element (for testing purposes)
    let target = document.getElementById('urlgoeshere');
    target.innerHTML = "URL Array: <br>" + resultString;

    // Debugging log
    console.log('Array of words to search for:', pathnameArray);

    // Perform search for each element in the array
    pathnameArray.forEach(function(item) {
      performSearch(item);  // Call performSearch for each shortened word in the array
    });
  }
}

// Perform search based on a query
function performSearch(query) {
  var encodedQuery = encodeURIComponent(query); // Ensure the query is URL encoded

  // Make AJAX call to the search API
  jQuery.ajax('/search/suggest.json?q=' + encodedQuery + '&resources[type]=product,collection,article', {
    type: 'GET',
    dataType: 'json',
    success: function(response) {
      console.log('Search results for: ' + query);
      console.log(response);

      // Initialize a string to hold the HTML for the search results
      let resultHTML = '';

// Process and display products
if (response.resources.results.products && response.resources.results.products.length > 0) {
  resultHTML += '<h3>' + ((window.qpI18n && window.qpI18n.products) || 'Products') + ':</h3><div class="collection-grid">';
  response.resources.results.products.forEach(function(product) {
    // Modify image URL to get a version that's 485px wide
    const imageUrl = product.featured_image.url;
	let resizedImage = imageUrl.replace(".jpg", "_485x485.jpg");
	console.log("img URL", imageUrl);
    resultHTML += `<div class="prodflex mobileGridForce"><a href="${product.url}"><img src="${resizedImage}" alt="${product.title}" />${product.title}</a></div>`;
  });
  resultHTML += '</div>';
} else {
  //resultHTML += '<p>No products found.</p>';
}

      // Process and display collections
      if (response.resources.results.collections && response.resources.results.collections.length > 0) {
        resultHTML += '<h3>' + ((window.qpI18n && window.qpI18n.collections) || 'Collections') + ':</h3><ul>';
        response.resources.results.collections.forEach(function(collection) {
          resultHTML += `<li><a href="${collection.url}">${collection.title}</a></li>`;
        });
        resultHTML += '</ul>';
      } else {
      //  resultHTML += '<p>No collections found.</p>';
      }

      // Process and display articles
      if (response.resources.results.articles && response.resources.results.articles.length > 0) {
        resultHTML += '<h3>' + ((window.qpI18n && window.qpI18n.articles) || 'Articles') + ':</h3><ul>';
        response.resources.results.articles.forEach(function(article) {
          resultHTML += `<li><a href="${article.url}">${article.title}</a></li>`;
        });
        resultHTML += '</ul>';
      } else {
      //  resultHTML += '<p>No articles found.</p>';
      }

      // Display the results in the target HTML element
      let target = document.getElementById('urlgoeshere');
      if (target) {
        target.innerHTML = resultHTML;
      } else {
      //  console.error("No element found with id 'urlgoeshere'.");
      }
    },
    error: function(error) {
      console.error('Error fetching search results:', error);
    }
  });
}










// Load jQuery and then execute other functions
loadJQuery(otherFunctions);


// ajax cart
// CRO 2026-08-31 - add to cart is one round trip and the drawer opens on the tap.
// The old flow ran add -> /cart.js -> section fetch one after another (five trips with a free
// gift), with an invisible overlay eating every tap for 1.6-2.1s. Now the drawer slides in
// immediately with a loading bar, and /cart/add.js returns the re-rendered drawer in the same
// response (Section Rendering API). The free gift check runs alongside, not in front.
// suggestion-card forms (.qpUpForm in the drawer, .qpPgUpForm on the cart page) have their
// own single-trip handlers - this one is for the product page buy form only
document.querySelectorAll('form[action="/cart/add"]:not(.qpUpForm):not(.qpPgUpForm)').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (form.dataset.qpBusy === '1') return; // ignore taps while an add is in flight

    // (2026-09-01) The old "no option selected" guard is gone: no template
    // renders its #optionWarning element, and #id can never be "none" - the
    // page loads with a variant selected and the picker auto-selects on load.

    form.dataset.qpBusy = '1';
    openCart();
    const qpDrawer = document.getElementById('ajaxCart');
    if (qpDrawer) {
      qpDrawer.classList.add('cart-drawer--loading');
      // first-ever add: the drawer still holds its server-rendered EMPTY state, which would
      // flash "Your Cart is Empty" while the add is in flight - hold on "Adding..." instead
      if (qpDrawer.querySelector('.qpEmpty')) qpDrawer.classList.add('cart-drawer--adding');
    }

    // free gift auto-add, in parallel with the main add; only if it actually adds
    // something does the drawer refresh again afterwards
    let giftPromise = null;
    const giftEl = document.querySelector('.freeGiftMessage');
    if (giftEl) {
      const giftVariantId = parseInt(giftEl.dataset.giftVariant, 10);
      const giftQty = parseInt(giftEl.dataset.giftQty, 10);
      if (giftVariantId && !isNaN(giftQty) && giftQty > 0) {
        giftPromise = fetch('/cart.js')
          .then(r => r.json())
          .then(cartCheck => {
            if (cartCheck.items.some(item => item.variant_id === giftVariantId)) return false;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1 }] })
            }).then(() => true);
          })
          .catch(err => { console.error('Free gift add failed, continuing without it:', err); return false; });
      }
    }

    try {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', '/');
      const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Add to cart failed');

      if (data.sections && data.sections['cart-drawer']) {
        swapDrawer(data.sections['cart-drawer']);
      } else {
        await updateCartDrawer();
      }

      // 2026-09-30: GA4 dataLayer push removed - it fed Google Tag Manager, which no store uses any more. Ecommerce events come from Shopify's native pixels (Google & YouTube app).

      if (giftPromise) giftPromise.then(added => { if (added) updateCartDrawer(); });
    } catch (err) {
      console.error('Add to cart failed:', err);
      await updateCartDrawer(); // resync the drawer to what the server actually holds
    } finally {
      form.dataset.qpBusy = '';
      if (qpDrawer) {
        qpDrawer.classList.remove('cart-drawer--loading');
        qpDrawer.classList.remove('cart-drawer--adding');
      }
    }
  });
});


////////////////////// product page qty buttons
document.addEventListener('DOMContentLoaded', function() {
  const minusButton = document.querySelector('.qty_minus');
  const quantityInput = document.getElementById('quantity');

  if (minusButton && quantityInput) {
    minusButton.addEventListener('click', function() {
      let currentValue = parseInt(quantityInput.value);
      if (!isNaN(currentValue)) {
        currentValue -= 1;

		if(currentValue > 0){
        quantityInput.value = currentValue;
		}
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const plusButton = document.querySelector('.qty_plus');
  const quantityInput = document.getElementById('quantity');

  if (plusButton && quantityInput) {
    plusButton.addEventListener('click', function() {
      let currentValue = parseInt(quantityInput.value);
      if (!isNaN(currentValue)) {
        currentValue += 1;
        quantityInput.value = currentValue;
      }
    });
  }
});




//////////////////// this is used for non triggered items
function lazyLoadImages(selector) {
  const lazyImages = document.querySelectorAll(selector);

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        // Replace with the high-resolution image URL logic
        const highResURL = entry.target.dataset.src; // Assuming data-src attribute is used
        entry.target.src = highResURL;

        // Remove "invisible" class from great grandparent
        const grandparent = entry.target.parentElement.parentElement.parentElement;
        //grandparent.classList.remove('animStartState'); // Assuming class name is 'invisible'
        grandparent.classList.add('fadeInUp-animation'); 

        observer.unobserve(entry.target); // Unobserve after replacing
      }
    });
  });

lazyImages.forEach((image, index) => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      observer.observe(image);
    }, index * 1000); // Adjust delay per image (e.g., 10 milliseconds per image)
  });
});

}

//lazyLoadImages('.lazy-load-placeholder2');











/// new lazy load which triggers with a trigger div rather than img intersects
function lazyLoadImagesFromTrigger(selector, triggerClass) {
  const lazyImages = document.querySelectorAll(selector);
  const triggerDivs = document.querySelectorAll(`.${triggerClass}`); // Select all divs with the trigger class

  if (!triggerDivs.length) {
    return; // No trigger divs found
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { // Check if any of the trigger divs are intersecting
        lazyImages.forEach((image, index) => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              const highResURL = image.dataset.src;
              image.src = highResURL;

              // Handle image loading error
              image.onerror = () => {
                console.error("Failed to load image:", highResURL);
                image.src = 'path_to_placeholder_image'; // Fallback image
              };

              /* The hidden element is the one carrying animStartState - a fixed
                 three-levels-up walk broke when the collection tile gained a
                 wrapper div (2026-09-05) and left tiles 5+ invisible. */
              const grandparent = image.closest('.animStartState') || image.parentElement.parentElement.parentElement;
              grandparent.classList.add('fadeInUp-animation');
            }, index * 100);
          });
        });

        // Stop observing this trigger div
        observer.unobserve(entry.target);
      }
    });
  });

  // Observe each trigger div
  triggerDivs.forEach(triggerDiv => observer.observe(triggerDiv));
}

// setup listeners for varioius lazyload elements
lazyLoadImagesFromTrigger('.lazy-image-from-trigger', 'lazyTriggerCollectionTiles');
lazyLoadImagesFromTrigger('.lazy-image-from-trigger2', 'lazyTriggerCollectionTiles2');
lazyLoadImagesFromTrigger('.lazy-load-blogPosts', 'lazyTriggerBlogPosts');
lazyLoadImagesFromTrigger('.lazy-load-may-also', 'lazyTriggerMayAlso');


// this is for others where a triggers not appropriate
lazyLoadImages('.lazy-load-placeholder');



// now lazy backgrounds
function lazyLoadBackgroundImages(selector) {
  const lazyBackgrounds = document.querySelectorAll(selector);

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const highResURL = entry.target.dataset.src;

        // Set the background-image style property
        entry.target.style.backgroundImage = `url(${highResURL})`;

        observer.unobserve(entry.target); // Unobserve after replacing
      }
    });
  });

  lazyBackgrounds.forEach(background => {
    observer.observe(background);
  });
}

lazyLoadBackgroundImages('.lazy-load-background');





// Function to ensure button widths are even to fix animations
function adjustButtonWidths() {
    // Array of target classes
    const targetClasses = [
        'bannerbuttonblack',
        'bannerbutton',
        'buyNowButtonAnimated'
    ];

    // Iterate over each class
    targetClasses.forEach((className) => {
        // Select all elements with the current class
        const elements = document.querySelectorAll(`.${className}`);

        elements.forEach((element) => {
            // CRO 2026-08-26 - skip the main buy button. It goes sticky on scroll
            // and its width is controlled by the sticky CSS (100% of container).
            // Forcing an even pixel width here fights the sticky container and
            // makes the button overflow when sticky is active.
            if (element.id === 'productBuyNowButton') return;

            // Get the current width
            const currentWidth = element.offsetWidth;

            // Check if the width is odd
            if (currentWidth % 2 !== 0) {
                // Reduce width by 1 pixel
                element.style.width = `${currentWidth - 1}px`;
            }
        });
    });
}



// Run on page load AND whenever a target button resizes
window.addEventListener('DOMContentLoaded', () => {
  console.log('[btn-width] DOMContentLoaded fired');
  adjustButtonWidths();

  const targetSelector = '.bannerbuttonblack, .bannerbutton, .buyNowButtonAnimated';
  // CRO 2026-08-26 - skip #productBuyNowButton. See adjustButtonWidths() for why.
  const initialTargets = [...document.querySelectorAll(targetSelector)]
    .filter(el => el.id !== 'productBuyNowButton');
  console.log('[btn-width] Found', initialTargets.length, 'target elements on load:', initialTargets);

  if (typeof ResizeObserver === 'undefined') {
    console.warn('[btn-width] ResizeObserver not supported in this browser');
    return;
  }

const observer = new ResizeObserver(entries => {
  console.log('[btn-width] ResizeObserver fired for', entries.length, 'entry/entries');
  for (const entry of entries) {
    const el = entry.target;
    // CRO 2026-08-26 - defensive skip; adjustButtonWidths() also skips this element.
    if (el.id === 'productBuyNowButton') continue;
    const prev = el.style.width;
    el.style.removeProperty('width');
    const w = el.offsetWidth;
    console.log('[btn-width]  →', el, 'natural width:', w, 'odd?', w % 2 !== 0);
    if (w % 2 !== 0) {
      el.style.setProperty('width', `${w - 1}px`, 'important');
      console.log('[btn-width]  → adjusted to', el.style.width);
    } else if (prev) {
      el.style.removeProperty('width');
    }
  }
});

  initialTargets.forEach(el => {
    observer.observe(el);
    console.log('[btn-width] Now observing', el);
  });

  // Also re-measure on viewport resize (dramatic width jumps can leave the input stuck)
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    initialTargets.forEach(el => {
      el.style.removeProperty('width');
      const w = el.offsetWidth;
      if (w % 2 !== 0) {
        el.style.setProperty('width', `${w - 1}px`, 'important');
      }
    });
  }, 100);
});
});